import React from 'react';
import {LucideIcon} from 'lucide-react';
import {AppSmallText, AppCardTitle} from '../../../../constants';

interface CreditInfoMetricCardProps {
  title: string;
  value: string;
  icon: LucideIcon;
  bgColor: string;
  iconColor: string;
  textColor: string;
  valueColor: string;
}

export const CreditInfoMetricCard: React.FC<CreditInfoMetricCardProps> = ({
  title,
  value,
  icon: Icon,
  bgColor,
  iconColor,
  textColor,
  valueColor
}) => {
  return (
    <div className={`${bgColor} p-4 rounded-lg`}>
      <div className="flex items-center gap-2 mb-2">
        <Icon className={`h-4 w-4 ${iconColor}`} />
        <AppSmallText className={`font-medium ${textColor}`}>{title}</AppSmallText>
      </div>
      <AppCardTitle className={`${valueColor}`}>{value}</AppCardTitle>
    </div>
  );
};
